import React from 'react';

import LoadingCell from '../LoadingCell';
import Highlighter from 'react-highlight-words';

import { Typography } from 'antd';

const { Text } = Typography;

import { ItemTypes } from '../../../../constants/constants';
import icons from '../../../../../../shared/utils/files/antIcons';

import { escapeRegex, isGuid } from '../../../../../../shared/utils';

export default (viewLayoutOptions) => (cellProps) => {
  if (viewLayoutOptions.loading) {
    return <LoadingCell />;
  }

  const isSearchApplied = cellProps.dataKey === 'description' && cellProps.rowData.searchString && cellProps.rowData.searchString.length > 0;

  const data = (viewLayoutOptions.getData ? viewLayoutOptions.getData(viewLayoutOptions, cellProps) : cellProps.cellData) || '';

  const defaultMargin = '5px';

  const descriptionInfoTooltip = () => {
    return (
      <>
        {cellProps.rowData.insuredVisible ? (
          <span style={{ marginRight: defaultMargin }} title="File shortcut in Insured Visible Folder">
            {icons.visible}
          </span>
        ) : null}
        {isGuid(cellProps.rowData.noteId) ? (
          <span style={{ marginRight: defaultMargin }} title="File shortcut in Note Folder">
            {icons.check}
          </span>
        ) : null}
        {isGuid(cellProps.rowData.taskId) ? (
          <span style={{ marginRight: defaultMargin }} title="Fileshortcut in Task Folder">
            {icons.unorderedList}
          </span>
        ) : null}
        {isGuid(cellProps.rowData.serviceRequestId) ? (
          <span style={{ marginRight: defaultMargin }} title="File shortcut in Service Request Folder">
            {icons.star}
          </span>
        ) : null}
        <span style={{ marginRight: defaultMargin }} title={cellProps.rowData.description}>
          {cellProps.rowData.description}
        </span>
      </>
    );
  };

  let cellData =
    isSearchApplied && data ? (
      <Highlighter
        highlightClassName="highlighted-text"
        searchWords={[escapeRegex(cellProps.rowData.searchString)]}
        caseSensitive={false}
        textToHighlight={data}
      />
    ) : cellProps.dataKey === 'description' &&
      cellProps.rowData.type === ItemTypes.File &&
      (cellProps.rowData.insuredVisible ||
        isGuid(cellProps.rowData.noteId) ||
        isGuid(cellProps.rowData.taskId) ||
        isGuid(cellProps.rowData.serviceRequestId)) ? (
      descriptionInfoTooltip()
    ) : (
      data || ''
    );

  const title =
    cellProps.dataKey === 'size' && cellProps.rowData.type === ItemTypes.Directory
      ? 'Amount of direct children of the folder. May contain more files/folders in subfolders.'
      : data || '';

  return (
    <div title={title}>
      <Text>{cellData}</Text>
    </div>
  );
};
